/* Turkey Tail – Theme-Logik: Light/Dark, Menü, Warenkorb (AJAX), Packungen, Produktseite */
(function () {
  'use strict';

  var cfg = window.ttMoney || { currency: 'EUR', locale: 'de' };
  function money(cents) {
    try {
      return new Intl.NumberFormat(cfg.locale || 'de', { style: 'currency', currency: cfg.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function setCount(n) { $$('[data-tt-cart-count]').forEach(function (el) { el.textContent = n; }); }

  /* ---------- Light / Dark ---------- */
  function applyThemeUi() {
    var dark = document.documentElement.getAttribute('data-theme') === 'dark';
    $$('[data-tt-theme-toggle]').forEach(function (b) {
      var label = dark ? 'Helle Ansicht' : 'Dunkle Ansicht';
      b.setAttribute('aria-label', label); b.setAttribute('title', label);
    });
    var meta = $('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', dark ? '#141210' : '#f6f2ec');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tt-theme-toggle]');
    if (!t) return;
    var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('tt-theme', next); } catch (err) {}
    applyThemeUi();
  });
  applyThemeUi();

  /* ---------- Mobilmenü ---------- */
  document.addEventListener('click', function (e) {
    var hdr = $('[data-tt-header]');
    var burger = e.target.closest('[data-tt-burger]');
    if (burger && hdr) {
      var open = hdr.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open);
      burger.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      $('[data-tt-burger-open]', burger).hidden = open;
      $('[data-tt-burger-close]', burger).hidden = !open;
      return;
    }
    if (hdr && hdr.classList.contains('is-open') && e.target.closest('.tt-mobilenav a')) {
      hdr.classList.remove('is-open');
      var b = $('[data-tt-burger]', hdr);
      if (b) { b.setAttribute('aria-expanded', 'false'); $('[data-tt-burger-open]', b).hidden = false; $('[data-tt-burger-close]', b).hidden = true; }
    }
  });

  /* ---------- Warenkorb-API ---------- */
  function addToCart(id, qty, plan) {
    var body = { items: [{ id: Number(id), quantity: qty || 1 }] };
    if (plan) body.items[0].selling_plan = Number(plan);
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; });
    });
  }
  function goCart() { window.location.href = window.routes.cart_url; }

  /* ---------- Startseite: Packungen ---------- */
  function initPacks(root) {
    var mode = root.querySelector('[data-tt-mode]') ? 'abo' : 'once';
    var pct = Number(root.getAttribute('data-abo-pct')) || 0;
    function render() {
      $$('[data-tt-card]', root).forEach(function (c) {
        var price = Number(c.dataset.price), compare = Number(c.dataset.compare) || 0, months = Number(c.dataset.months) || 1;
        var now = mode === 'abo' ? Number(c.dataset.aboPrice) : price;
        var old = compare > price ? compare : (mode === 'abo' ? price : 0);
        c.querySelector('[data-tt-price]').textContent = money(now);
        var oldEl = c.querySelector('[data-tt-old]');
        if (oldEl) { oldEl.textContent = money(old); oldEl.hidden = !old; }
        c.querySelector('[data-tt-month]').textContent = money(now / months);
        var save = old > now ? Math.round((1 - now / old) * 100) : 0, saveEl = c.querySelector('[data-tt-save]');
        if (saveEl) { saveEl.textContent = 'Spare ' + save + ' %'; saveEl.hidden = !save; }
      });
      $$('[data-tt-mode]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.ttMode === mode); });
    }
    root.addEventListener('click', function (e) {
      var m = e.target.closest('[data-tt-mode]');
      if (m) { mode = m.dataset.ttMode; try { sessionStorage.setItem('tt-mode', mode); } catch (er) {} render(); return; }
      var btn = e.target.closest('[data-tt-add]');
      if (!btn) return;
      var c = btn.closest('[data-tt-card]');
      btn.disabled = true;
      addToCart(c.dataset.variant, 1, mode === 'abo' ? c.dataset.plan : '').then(goCart).catch(function () { btn.disabled = false; });
    });
    try { var s = sessionStorage.getItem('tt-mode'); if (s && root.querySelector('[data-tt-mode]')) mode = s; } catch (er) {}
    render();
  }

  /* ---------- Produktseite ---------- */
  function initPdp(root) {
    var form = $('[data-tt-form]', root), st = $('[data-tt-state]', form);
    var hasAbo = !!$('[data-tt-mode]', form), mode = hasAbo ? 'abo' : 'once', qty = 1;
    try { var s = sessionStorage.getItem('tt-mode'); if (s && hasAbo) mode = s; } catch (er) {}
    var plan = $('[data-tt-plan]', form), qtyIn = $('[data-tt-qty]', form), qtyOut = $('[data-tt-qty-out]', form);
    var total = $('[data-tt-total]', form), err = $('[data-tt-error]', form), submit = $('[data-tt-submit]', form);
    function render() {
      var unit = mode === 'abo' ? Number(st.dataset.aboPrice) : Number(st.dataset.price);
      if (total) total.textContent = money(unit * qty);
      qtyOut.textContent = qty; qtyIn.value = qty;
      plan.value = (mode === 'abo' && st.dataset.plan) ? st.dataset.plan : '';
      $$('[data-tt-mode]', form).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.ttMode === mode); });
      $$('.tt-opt', form).forEach(function (o) {
        var p = Number(mode === 'abo' ? o.dataset.aboPrice : o.dataset.price), m = Number(o.dataset.months) || 1;
        var a = $('[data-tt-opt-price]', o), b = $('[data-tt-opt-month]', o);
        if (a) a.textContent = money(p); if (b) b.textContent = money(p / m);
      });
    }
    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-tt-inc]')) { qty = Math.min(99, qty + 1); render(); }
      else if (e.target.closest('[data-tt-dec]')) { qty = Math.max(1, qty - 1); render(); }
      else {
        var m = e.target.closest('[data-tt-mode]');
        if (m) { mode = m.dataset.ttMode; try { sessionStorage.setItem('tt-mode', mode); } catch (er) {} render(); }
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true; submit.disabled = true;
      addToCart($('[name="id"]', form).value, qty, plan.value).then(goCart).catch(function (ex) {
        err.textContent = ex.message; err.hidden = false; submit.disabled = false;
      });
    });
    var main = $('#tt-main-img', root);
    $$('[data-tt-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        main.removeAttribute('srcset'); main.src = t.dataset.ttThumb;
        $$('[data-tt-thumb]', root).forEach(function (o) { o.setAttribute('aria-current', o === t); });
      });
    });
    render();
  }

  /* ---------- Warenkorbseite ---------- */
  function initCart() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tt-line]');
      var root = e.target.closest('[data-tt-cart]');
      if (!b || !root) return;
      root.classList.add('is-loading');
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.ttLine), quantity: Number(b.dataset.qty) })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        setCount(cart.item_count);
        return fetch(window.routes.cart_url + '?section_id=' + root.dataset.sectionId).then(function (r) { return r.text(); });
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-tt-cart]');
        if (fresh) root.replaceWith(fresh); else window.location.reload();
      }).catch(function () { window.location.reload(); });
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-tt-code-form]');
      if (!f) return;
      e.preventDefault();
      var code = f.elements.code.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.routes.cart_url);
    });
  }

  function boot() {
    $$('[data-tt-packs]').forEach(initPacks);
    $$('[data-tt-pdp]').forEach(initPdp);
    initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
